export const TENANT_HEADER = '__tenant';

// Routes
export const ROUTES = 'booking/routes';

// Booking
export const SEARCH = 'booking/search';
export const BOOKING = 'booking';
export const CREATE_CHECKOUT_SESSION = 'booking/checkoutSession';